import React from "react";

const CompanyTypeView = () => {
  return <div>CompanyTypeView</div>;
};

export default CompanyTypeView;
